import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";

export const UnderNinetyNine = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { u99: true } }).then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  if (!products.length) return null;

  return (
    <section data-testid="under-99-section" className="bg-powder/40 py-24 sm:py-32">
      <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
        <Reveal>
          <div className="mb-16 flex flex-wrap items-end justify-between gap-6">
            <div>
              <p className="mb-4 text-xs uppercase tracking-[0.3em] text-taupe">Little upgrades, honest prices</p>
              <h2 className="font-serif text-3xl font-light tracking-tight sm:text-4xl lg:text-5xl">
                Everything under $99
              </h2>
            </div>
            <Link
              to="/shop?maxprice=99"
              data-testid="u99-view-all"
              className="group flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-ash transition-colors duration-300 hover:text-charcoal"
            >
              Shop all under $99
              <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
        <div className="grid grid-cols-2 gap-6 md:grid-cols-4 md:gap-10">
          {products.slice(0, 4).map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.06}>
              <ProductCard product={p} ratio="aspect-[4/5]" />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
